module.exports = __webpack_public_path__ + "static/media/beckman.27987b90.png";